import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { CheckCircle2, PartyPopper } from 'lucide-react'
import { useBooking } from '../../store/bookingStore'
import { Button } from '../../components/ui/Button'
import { stepPath } from '../../lib/steps'

/** Step 5 — booking confirmation. Shows the result stored by the payment step. */
export function SummaryStep() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { locale: routeLocale = 'it' } = useParams()
  const confirmation = useBooking((s) => s.confirmation)
  const reset = useBooking((s) => s.reset)

  // Reached without a completed booking (e.g. refresh / direct nav) → back to start.
  useEffect(() => {
    if (!confirmation) navigate(stepPath(routeLocale, 'dates'), { replace: true })
  }, [confirmation, navigate, routeLocale])

  if (!confirmation) return null

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-ink-50 px-4 py-16 text-center">
      <span className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-brand-50 text-brand-600">
        <CheckCircle2 className="h-10 w-10" />
      </span>
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-ink-900">
        {confirmation.title || t('summary.confirmed')}
      </h1>
      <p className="mt-2 flex items-center gap-2 text-ink-500">
        <PartyPopper className="h-4 w-4" /> {t('summary.code')}:{' '}
        <span className="font-mono text-lg font-bold text-ink-900">{confirmation.code}</span>
      </p>
      {confirmation.text && (
        <div className="mt-5 max-w-lg text-sm text-ink-500 [&_p]:my-1" dangerouslySetInnerHTML={{ __html: confirmation.text }} />
      )}
      <Button
        className="mt-8"
        size="lg"
        onClick={() => {
          reset()
          navigate(stepPath(routeLocale, 'dates'))
        }}
      >
        {t('brand.name')}
      </Button>
    </div>
  )
}
